// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"qr_a bhs_rq bhs_kr bhs_ks","PostDetailRight__brandDaysPosts":"qr_b bhs_rq bhs_kr bhs_ks"};